"use client";

import type { ReactElement } from "react";
import { TimelineCanvas } from "./TimelineCanvas";
import { TimelineScrollShell } from "./TimelineScrollShell";
import { TimelineTooltip } from "./TimelineTooltip";
import type { TimelineRootModel } from "./useTimelineRootModel";
import type { TimelineLayoutMetrics } from "./timeline-root-types";
import type { ParsedTimeline } from "./timeline-types";

export interface TimelineViewportProps {
  layout: TimelineLayoutMetrics;
  model: TimelineRootModel;
  parsed: ParsedTimeline;
  viewportHeight: number;
}

export function TimelineViewport({
  layout,
  model,
  parsed,
  viewportHeight,
}: TimelineViewportProps): ReactElement {
  const { needleController, scrollController, snapModel, tooltipController } =
    model;

  return (
    <TimelineScrollShell
      onMouseEnter={needleController.handleNeedleMouseEnter}
      onMouseMove={needleController.handleNeedleMouseMove}
      onMouseLeave={needleController.handleNeedleMouseLeave}
      onPointerDown={needleController.handleTouchFocus}
      scrollContainerRef={scrollController.scrollContainerRef}
      viewportHeight={viewportHeight}
    >
      <TimelineCanvas
        centeredPeriodIndex={scrollController.centeredPeriodIndex}
        collapsedSections={model.collapsedSections}
        innerRef={scrollController.innerRef}
        isNeedleReady={needleController.isNeedleReady}
        layout={layout}
        needleActive={needleController.needleActive}
        needleOpacity={needleController.needleOpacity}
        onHoverEvent={tooltipController.handleHoverEvent}
        onToggleSection={model.handleToggleSection}
        parsed={parsed}
        periodRefs={scrollController.periodRefs}
        sectionBoundaryIndices={model.metrics.sectionBoundaryIndices}
        sidePad={model.metrics.sidePad}
        snapCandidateCount={snapModel.snapCandidates.length}
        snappedNeedleX={needleController.snappedNeedleX}
        snappedPeriodIndex={needleController.snappedPeriodIndex}
        snappedSectionColor={snapModel.snappedSectionColor}
        trackHighlightGradient={snapModel.trackHighlightGradient}
      />
      <TimelineTooltip
        tooltip={tooltipController.hoveredEventTooltip}
        tooltipPosition={tooltipController.tooltipPosition}
        tooltipRef={tooltipController.tooltipRef}
      />
    </TimelineScrollShell>
  );
}
